import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppState } from '../../config/state';

/*
  Generated class for the SoundsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SoundsProvider {
  soundEnabled: boolean = true;
  buttonSound: any;
  keySound: any;
  beepSound: any;
  constructor(public http: HttpClient, private state : AppState) {
    this.buttonSound = new Audio('assets/sounds/buttonclick.mp3');
    this.buttonSound.loop = false;
    this.keySound = new Audio('assets/sounds/keyboardclick.mp3');
    this.keySound.loop = false;

	this.beepSound = new Audio('assets/sounds/scan-beep.mp3');
    this.beepSound.loop = false;
    this.soundEnabled = this.state.enableSounds;
  }
  public playSoundOnButtonClick(el?:HTMLElement){
    if (this.soundEnabled){
      let buttonsCollection = el? el.getElementsByClassName('button') : document.getElementsByClassName('button');
      let arr = Array.from(buttonsCollection)
      // console.log(buttonsCollection);

      if (arr.length > 0) {
          arr.forEach(b =>{
          b.addEventListener('click', e =>{
            this.ButtonClick();
          })
        });
      }
    }
  }
  public ButtonClick(){
    if (this.soundEnabled){
      this.buttonSound.play();
    }
  }

  public playClickSound(){
    if (this.soundEnabled){
      // const buttonSound = new Audio('assets/sounds/buttonclick.mp3');
      // buttonSound.loop = false;
      this.buttonSound.play();
    }
  }

  public playKeyboardSound(){
    if (this.soundEnabled){
      this.keySound.play();
    }
  }
  public playBeepSound(){
    if (this.soundEnabled){
      this.beepSound.play();
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/sounds/sounds.ts